export default "<section>\n  <app-trades [inputMode]=\"mode\"></app-trades>\n</section>\n";